// Isolated V2 verify modal. Uses Interview1003ViewV2; do not import from the legacy DocumentChecklist.js.
import React, { useState, useEffect, useLayoutEffect, useRef, useCallback } from 'react';
import { connect } from 'react-redux'
import { Modal, Pagination, Button, Image, Dropdown, Row, Col, Select, Skeleton, message } from 'antd';
import { CloseOutlined, MinusOutlined, PlusOutlined } from '@ant-design/icons';
import Interview1003ViewV2 from "../Interview1003View/Interview1003ViewV2";
import { cloneDeep } from 'lodash';
import { Document, Page, pdfjs } from 'react-pdf';
import './VerifyModalV2.css';
import { useStatsigClient } from '@statsig/react-bindings';
import { getLosApplicationV2 } from './applicationV2Client'
import { v2ToLegacyApplication } from './applySmartVerifyV2'
import {
    matchSubjectFromTaskName,
    resolveSmartVerifyParties,
    subjectsFromLegacyApplication,
    subjectsFromParticipantsV2,
} from './documentSubjects'
import { track } from 'statsig'
import { STATSIG } from 'statsig/events'

const mapStateToProps = (state) => {
    return {
        application: state.application,
        progress: state.progress,
        borrower: state.borrower,
    }
}
const mapDispatchToProps = () => ({})
export default function VerifyModal(props) {
    pdfjs.GlobalWorkerOptions.workerSrc =
        `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
    const {
        mode, data, open, file, files, pageNumber, numPages, scale, loanid, onCancel, extractedData, mappingData, complete, change, loadSuccess, handlePage, handleZoom, manualVerify, handleDocument, startVerifyTime
    } = props;
    const [hoveredKey, setHoveredKey] = useState(null)
    const [updatedKeys, setUpdatedKeys] = useState({})
    const [data1, setData1] = useState([])
    const [data2, setData2] = useState([])
    const [data3, setData3] = useState([])
    const [currentData, setCurrentData] = useState([])
    const [initialData, setInitialData] = useState([])
    const [currentData2, setCurrentData2] = useState([])
    const [initialData2, setInitialData2] = useState([])
    const [isUpdateAll, setIsUpdateAll] = useState(false)
    const [pageWidth, setPageWidth] = useState(0)
    const [changeSaved, setChangeSaved] = useState(false)
    const [viewType, setViewType] = useState("")
    const [borrowerOptions, setBorrowerOptions] = useState([])
    const [verifyConfirmStatus, setVerifyConfirmStatus] = useState(false)
    const containerRef = useRef(null)
    const manualChangeTimeout = useRef(null)
    const [currentPage, setCurrentPage] = useState(1)
    const isManualChange = useRef(false)
    const isAtBoundary = useRef(false)
    const isLeftSyncing = useRef(false)
    const justSwitched = useRef(false)
    const [previewBarVisible, setPreviewBarVisible] = useState(false)
    const [hideTimeout, setHideTimeout] = useState(null)
    const [visiblePages, setVisiblePages] = useState([])
    const [smartLeftName, setSmartLeftName] = useState('')
    const [smartRightName, setSmartRightName] = useState('')
    const pageRefs = useRef([])
    const observerRef = useRef(null)
    const smartCtxRef = useRef(null)
    const { client } = useStatsigClient()
    useEffect(() => {
        let cancelled = false
        const runSmart = async () => {
            if (!(open && mode === 'smart' && files && files.length > 0)) return
            try {
                const body = await getLosApplicationV2(loanid)
                if (cancelled) return
                const app = body.Application
                const byId = app?.participantsById || {}
                const fromAppSubjects = subjectsFromParticipantsV2(Object.values(byId))
                const propSubjects = (props.documentSubjects && props.documentSubjects.length)
                    ? props.documentSubjects
                    : []
                // Prefer full V2 participant list so 3rd+ coborrower docs match before Redux subjects refresh.
                const subjects = fromAppSubjects.length >= propSubjects.length ? fromAppSubjects : propSubjects
                const resolved = resolveSmartVerifyParties({
                    app,
                    subjects,
                    taskName: data?.taskName,
                })
                const {
                    showPrimaryColumn,
                    showSecondaryColumn,
                    primaryPartyId,
                    secondaryPartyId,
                    primaryDisplayName,
                    secondaryDisplayName,
                } = resolved
                setSmartLeftName(showPrimaryColumn ? primaryDisplayName : "")
                setSmartRightName(showSecondaryColumn ? secondaryDisplayName : "")
                smartCtxRef.current = {
                    v2Application: app,
                    leftPartyId: primaryPartyId,
                    rightPartyId: secondaryPartyId,
                }
                const legacyApp = v2ToLegacyApplication(
                    app,
                    primaryPartyId,
                    showSecondaryColumn ? secondaryPartyId : "",
                )
                const extractedResults = []
                const mappingResults = []
                const mappingResults2 = []
                // A file with no field map contributes a blank to all three
                // columns rather than being skipped. The three arrays are read
                // by index -- data1[i] is the document, data2[i]/data3[i] the
                // borrowers -- so dropping a file from one of them shifts every
                // file after it and puts one document's values beside another
                // document's row. Nothing showed it while an unmapped file sent
                // the whole task to Complete verification; now that one mapped
                // file is enough, mixed tasks are the normal case.
                files.forEach(file => {
                    const mapping = file?.Mapping1003
                    if (!mapping || typeof mapping !== "object" || Object.keys(mapping).length === 0) {
                        extractedResults.push({})
                        if (showPrimaryColumn) mappingResults.push({})
                        if (showSecondaryColumn) mappingResults2.push({})
                        return
                    }
                    const docSource = getSmartVerifyDocSource(file.ExtractedData)
                    const extractedResult = mapData(mapping, file.ExtractedData, docSource, 'DocPath')
                    if (showPrimaryColumn) {
                        mappingResults.push(mapData(mapping, file.ExtractedData, legacyApp, 'StatePath'))
                    }
                    if (showSecondaryColumn) {
                        mappingResults2.push(mapData(processMappingData(mapping), file.ExtractedData, legacyApp, 'StatePath'))
                    }
                    extractedResults.push(extractedResult)
                })
                if (cancelled) return
                setData1(extractedResults)
                if (showPrimaryColumn && mappingResults.length > 0) {
                    setData2(mappingResults)
                    setCurrentData(mappingResults)
                    setInitialData(mappingResults)
                } else {
                    setData2([])
                    setCurrentData([])
                    setInitialData([])
                }
                if (showSecondaryColumn && mappingResults2.length > 0) {
                    setData3(mappingResults2)
                    setCurrentData2(mappingResults2)
                    setInitialData2(mappingResults2)
                } else {
                    setData3([])
                    setCurrentData2([])
                    setInitialData2([])
                }
                setHoveredKey({})
                setUpdatedKeys({})
                setIsUpdateAll(false)
            } catch (err) {
                if (!cancelled) {
                    smartCtxRef.current = null
                    setData1([])
                    setData2([])
                    setCurrentData([])
                    setInitialData([])
                    setData3([])
                    setCurrentData2([])
                    setInitialData2([])
                    console.error(err)
                    message.error(err.message || "Failed to load application from split tables")
                }
            }
        }
        if (open && mode === 'smart') {
            runSmart()
        } else if (open && mode === 'manual') {
            const subjects = (props.documentSubjects && props.documentSubjects.length)
                ? props.documentSubjects
                : subjectsFromLegacyApplication(props.application)
            const matched = matchSubjectFromTaskName(data?.taskName, subjects)
            const options = []
            subjects.forEach((subject) => {
                if (matched && matched.suffix && subject.suffix !== matched.suffix) return
                options.push({
                    value: subject.partyId || (subject.isPrimary ? "primary" : subject.suffix),
                    label: subject.fullName,
                    partyId: subject.partyId || "",
                    has1003: true,
                })
            })
            if (options.length === 0) {
                options.push({
                    value: "primary",
                    label: `${props.application.borrower.firstname} ${props.application.borrower.lastname}`,
                    partyId: "",
                    has1003: true,
                })
            }
            setBorrowerOptions(options)
            const matchedOption = matched
                ? options.find((o) => o.label === matched.fullName || (matched.suffix && o.value === matched.partyId))
                : null
            setViewType(matchedOption?.value || options[0].value)
        }
        return () => {
            cancelled = true
        }
    }, [open, files, mode, loanid, data?.taskName, props.documentSubjects])
    useEffect(() => {
        return () => {
            if (hideTimeout) {
                clearTimeout(hideTimeout)
            }
        };
    }, [hideTimeout])
    useEffect(() => {
        if (open) {
            setCurrentPage(1)
        }
    }, [open])
    useEffect(() => {
        return () => {
            if (manualChangeTimeout.current) {
                clearTimeout(manualChangeTimeout.current)
            }
        }
    }, [])
    useLayoutEffect (() => {
        if (open && mode === 'manual') {
            const handleResize = () => {
                if (containerRef.current) {
                    setPageWidth(containerRef.current.offsetWidth - 24)
                }
            }
            setTimeout(handleResize, 0)
            window.addEventListener('resize', handleResize)
    
            return () => {
                window.removeEventListener('resize', handleResize)
            }
        }
    }, [open, mode])

    const resetScrollHandling = () => {
        containerRef.current.removeEventListener('scroll', resetScrollHandling)
        containerRef.current.addEventListener('scroll', handleScroll)
    }

    const handleScroll = () => {
        if (isManualChange.current || isLeftSyncing.current) return
        const scrollTop = containerRef.current.scrollTop
        const containerHeight = containerRef.current.offsetHeight
        const scrollHeight = containerRef.current.scrollHeight
    
        if (handleScroll.lastScrollTop === undefined) {
            handleScroll.lastScrollTop = 0
        }
        const isScrollingDown = scrollTop > handleScroll.lastScrollTop
        handleScroll.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop
    
        if (justSwitched.current) {
            return
        }
        
        if (isAtBoundary.current) {
            isAtBoundary.current = false
            return
        }
        if (isScrollingDown && scrollTop + containerHeight >= scrollHeight) {
            changeFile('next')
    
            containerRef.current.removeEventListener('scroll', handleScroll)
    
            requestAnimationFrame(() => {
                containerRef.current.addEventListener('scroll', resetScrollHandling)
            })
        } else if (!isScrollingDown && scrollTop <= 0) {
            changeFile('prev')
    
            containerRef.current.removeEventListener('scroll', handleScroll)
    
            requestAnimationFrame(() => {
                containerRef.current.addEventListener('scroll', resetScrollHandling)
            })
        }
        const anchors = document.querySelectorAll('.pdf-verify-anchor')
        let closestPage = currentPage
        let minDistance = Infinity
    
        anchors.forEach(anchor => {
            const { top } = anchor.getBoundingClientRect()
            const distance = Math.abs(top - containerHeight / 2)
            if (distance < minDistance) {
                minDistance = distance
                closestPage = parseInt(anchor.id.split('-')[1])
            }
        })
    
        if (closestPage !== currentPage) {
            setCurrentPage(closestPage)
        }
    
        setTimeout(() => {
            isLeftSyncing.current = false
        }, 100)
    }

    const changeFile = (type) => {
        justSwitched.current = true
        let newPage
        const toNum = type === 'prev' ? data?.num - 1 : data?.num + 1
        if (type === 'prev' && data && data?.num !== 1) {
            change(toNum)
            newPage = 1
        } else if (type === 'next' && data && data?.num !== data?.total) {
            change(toNum)
            newPage = 1
        } else {
            newPage = currentPage
        }
        setCurrentPage(newPage)
        setTimeout(() => {
            justSwitched.current = false
        }, 500)
    }
    const verifyCancel = () => {
        onCancel()
    }

    // ParsedData wraps pages as { extractedData }; VerifiedData stores flat field objects per page.
    const getSmartVerifyDocSource = (extractedData) => {
        if (!Array.isArray(extractedData) || extractedData.length === 0) return {}
        const entry = extractedData.find((item) => item != null && typeof item === "object")
        if (!entry) return {}
        if (entry.extractedData != null && typeof entry.extractedData === "object") {
            return entry.extractedData
        }
        return entry
    }

    const processMappingData = (mappingData) => {
        const newMappingData = cloneDeep(mappingData)
      
        const processField = (field) => {
          if (field.StatePath) {
            field.StatePath = field.StatePath.replace(/\bborrower\b/g, 'coborrower');
          }
      
          if (field.StateChanges) {
            field.StateChanges = field.StateChanges.map(change => ({
              ...change,
              path: change.path.replace(/\bborrower\b/g, 'coborrower')
            }))
          }
        }
      
        const recursiveProcess = (obj) => {
          Object.keys(obj).forEach(key => {
            const field = obj[key]
            if (typeof field === 'object' && field !== null) {
              if (field.StatePath || field.StateChanges) {
                processField(field)
              } else {
                recursiveProcess(field)
              }
            }
          })
        }
      
        recursiveProcess(newMappingData)
      
        return newMappingData;
      };
    const getValueByPath = (obj, path, defaultValue = undefined) => {
        const parts = path.split('.')
        let result = obj
        for (let part of parts) {
            if (result && typeof result === 'object' && part in result) {
                result = result[part]
            } else {
                return defaultValue
            }
        }
        if (result && typeof result === 'object' && !Array.isArray(result)) {
            return defaultValue
        }
        return result
    }
    const mapData = (mapping, extractedData, source, sourceType) => {
        const result = {}
        Object.keys(mapping).forEach(key => {
            if (typeof mapping[key] === 'object' && mapping[key] !== null) {
                if (mapping[key][sourceType]) {
                    let value = getValueByPath(source, mapping[key][sourceType])
                    if (value !== '' && mapping[key].ValueType && mapping[key].ValueType === 'intstring') {
                        value = parseInt(value)
                    }
                    result[key] = value
                } else {
                    result[key] = mapData(mapping[key], extractedData, source, sourceType)
                }
            }
        })
        return result
    }
    const countDiscrepancies = (dataA, dataB, dataC) => {
        let count = 0
        const isEqual = (val1, val2) => (val1 === val2) || (val1 === "" && val2 === undefined) || (val1 === undefined && val2 === "")
        const recursiveCount = (objA, objB, objC) => {
            Object.keys(objA).forEach(key => {
                const valueA = objA[key]
                const valueB = objB ? objB[key] : undefined
                const valueC = objC ? objC[key] : undefined
    
                if (typeof valueA === 'object' && valueA !== null) {
                    recursiveCount(valueA, valueB, valueC)
                } else {
                    // One per column, not one per row. A field the document
                    // disagrees with both borrowers about is two things to
                    // settle, and counting it once meant accepting it for one
                    // of them changed nothing: the count stayed where it was,
                    // the footer kept offering "Dismiss suggestions", and the
                    // reviewer was told their update had done nothing.
                    if (objB && !isEqual(valueA, valueB)) {
                        count++
                    }
                    if (objC && !isEqual(valueA, valueC)) {
                        count++
                    }
                }
            })
        }
    
        if (dataB.length === 0 && dataC.length === 0) {
            return count
        } else if (dataB.length === 0) {
            dataA.forEach((itemA, index) => {
                const itemC = dataC[index] || {}
                recursiveCount(itemA, null, itemC)
            })
        } else if (dataC.length === 0) {
            dataA.forEach((itemA, index) => {
                const itemB = dataB[index] || {}
                recursiveCount(itemA, itemB, null)
            })
        } else {
            dataA.forEach((itemA, index) => {
                const itemB = dataB[index] || {}
                const itemC = dataC[index] || {}
                recursiveCount(itemA, itemB, itemC)
            })
        }
        return count
    }
    // A boolean renders as nothing at all in JSX, so a self-employed row read
    // from a profit and loss statement or a business return showed the
    // reviewer an empty cell and asked them to accept it.
    const forDisplay = (value) => {
        if (value === true) return 'Yes'
        if (value === false) return 'No'
        return value
    }
    const getNestedValue = (obj, path) => {
        return path.reduce((acc, key) => acc && acc[key], obj)
    }

    const setNestedValue = (obj, path, value) => {
        let target = obj
        path.forEach((key, idx) => {
            if (idx === path.length - 1) {
                target[key] = value
            } else {
                target = target[key]
            }
        })
    }
    // Which person "Update all" writes to. A document belongs to somebody -- a
    // profit and loss statement is one borrower's business, not both -- so it
    // fills the column this document was filed under and leaves the other
    // alone; the reviewer takes the other column a row at a time if they need
    // to. (The server's identity match is not available here: it runs inside
    // ApplyParsedDataToState, which a POS upload never reaches.)
    const updateAllColumn = () => {
        if (data2.length === 0) return 'secondary'
        if (data3.length === 0) return 'primary'
        return `${data?.forWhom || ''}` === 'coborrower' ? 'secondary' : 'primary'
    }
    const updateAll = () => {
        const column = updateAllColumn()
        const applicationValues = column === 'primary' ? data2 : data3
        if (applicationValues.length === 0) return
        const updatedKeys = {}
        const recursiveUpdate = (obj1, obj2, path = []) => {
            Object.keys(obj1).forEach(key => {
                const currentPath = [...path, key]
                const pathString = currentPath.join('.')
                const theirs = obj2 ? obj2[key] : undefined
                if (typeof obj1[key] === 'object' && obj1[key] !== null) {
                    recursiveUpdate(obj1[key], theirs, currentPath)
                } else if (obj1[key] !== theirs) {
                    updatedKeys[pathString] = { [column]: true }
                }
            })
        }
        setIsUpdateAll(true)
        recursiveUpdate(data1, applicationValues)
        setUpdatedKeys(updatedKeys)
        const filled = cloneDeep(data1)
        if (column === 'primary') setCurrentData(filled)
        else setCurrentData2(filled)
    }

    const undoAll = () => {
        setIsUpdateAll(false)
        setUpdatedKeys({})
        setCurrentData(cloneDeep(initialData))
        setCurrentData2(cloneDeep(initialData2))
    }
    const handleVerify = () => {
        const started = startVerifyTime?.current
        if (started > 0) {
            track(STATSIG.LOAN.DOCUMENT_PROCESS, Date.now() - started, { type: 'verify' })
        } else {
            track(STATSIG.LOAN.DOCUMENT_PROCESS, { type: 'verify' })
        }
        complete(currentData, currentData2, updatedKeys, smartCtxRef.current)
        if (startVerifyTime.current > 0 && client) {
            const verifyTime = Date.now() - startVerifyTime.current
            client.logEvent('document_processing_time', verifyTime, {
                verify_time: verifyTime,
                timestamp: Date.now().toString(),
                pageUrl: window.location.href,
                file_name: file.name,
                loan_id: props.loanid,
                application_id: props.application.id,
            })
        }
    }
    const manualComplete = () => {
        const nextPerson = borrowerOptions.find((item) => item.value !== viewType)
        if (borrowerOptions.length > 1 && nextPerson && borrowerOptions[0].value === viewType) {
            setVerifyConfirmStatus(true)
        } else {
            const started = startVerifyTime?.current
            if (started > 0) {
                track(STATSIG.LOAN.DOCUMENT_PROCESS, Date.now() - started, { type: 'manual' })
            } else {
                track(STATSIG.LOAN.DOCUMENT_PROCESS, { type: 'manual' })
            }
            manualVerify()
            if (startVerifyTime.current > 0 && client) {
                const verifyTime = Date.now() - startVerifyTime.current
                client.logEvent('document_processing_time', verifyTime, {
                    verify_time: verifyTime,
                    timestamp: Date.now().toString(),
                    pageUrl: window.location.href,
                    file_name: file.name,
                    loan_id: props.loanid,
                    application_id: props.application.id,
                })
            }
        }
    }
    const completeVerify = () => {
        setVerifyConfirmStatus(false)
        const started = startVerifyTime?.current
        if (started > 0) {
            track(STATSIG.LOAN.DOCUMENT_PROCESS, Date.now() - started, { type: 'manual' })
        } else {
            track(STATSIG.LOAN.DOCUMENT_PROCESS, { type: 'manual' })
        }
        manualVerify()
    }
    const saveProgress = () => {
        setChangeSaved(true)
        setTimeout(() => setChangeSaved(false), 3000)
    }
    const arrayBufferToBlob = (buffer, type) => {
        return new Blob([buffer], { type })
    }
    const createImageURLFromBase64 = (arrayBuffer, type) => {
        const blob = arrayBufferToBlob(arrayBuffer, type)
        return URL.createObjectURL(blob)
    }
    const onDocumentLoadSuccess = (page) => {
        loadSuccess(page)
        setVisiblePages([1])
    }
    const createObserver = useCallback((entries) => {
        entries.forEach((entry) => {
            const pageNum = parseInt(entry.target.dataset.page, 10)
            if (entry.isIntersecting) {
                setVisiblePages((prevPages) => {
                    if (!prevPages.includes(pageNum)) {
                        return [...prevPages, pageNum]
                    }
                    return prevPages
                })
            }
        })
    }, [])

    useEffect(() => {
        observerRef.current = new IntersectionObserver(createObserver, {
            root: containerRef.current,
            rootMargin: '0px',
            threshold: 0.1
        })

        return () => {
            if (observerRef.current) {
                observerRef.current.disconnect();
            }
        }
    }, [createObserver])
    useEffect(() => {
        if (pageRefs.current.length && observerRef.current) {
            pageRefs.current.forEach((pageRef) => {
                if (pageRef) observerRef.current.observe(pageRef)
            })
        }

        return () => {
            if (observerRef.current) {
                pageRefs.current.forEach((pageRef) => {
                    if (pageRef) observerRef.current.unobserve(pageRef)
                })
            }
        }
    }, [numPages, visiblePages])
    const onChangePage = (page) => {

        isManualChange.current = true

        if (page === 1 || page === numPages) {
            isAtBoundary.current = true
        } else {
            isAtBoundary.current = false
        }
    
        setCurrentPage(page)
        const pdfTargetElement = document.querySelector(`#pdfVerifyPage-${page}`)
    
        if (pdfTargetElement) {
            containerRef.current.scrollTo({
                top: pdfTargetElement.offsetTop,
                behavior: 'smooth',
            })
        }
    
        if (manualChangeTimeout.current) {
            clearTimeout(manualChangeTimeout.current)
        }

        manualChangeTimeout.current = setTimeout(() => {
            isManualChange.current = false
        }, 500)
    }
    const changeZoom = (type) => {
        if (type === 'add') {
            handleZoom(+(Math.min(scale + 0.1, 3).toFixed(1)));
        } else {
            handleZoom(+(Math.max(scale - 0.1, 0.5).toFixed(1)));
        }
    }
    const handleDoc = (e) => {
        handleDocument(e.key)
    }
    const isEqual = (val1, val2) => {
        return (val1 === val2) || (val1 === undefined && val2 === "") || (val1 === "" && val2 === undefined);
    };
    const RecursiveTable = ({
        documentData,
        applicationData,
        secondaryApplicationData,
        level = 0,
        path = [],
        hoveredKey,
        setHoveredKey,
        fileName,
        fileIndex
    }) => {
        if (!documentData || (!applicationData && !secondaryApplicationData)) {
            return null;
        }
    
        return (
            <div>
                {Object.keys(documentData).map(key => {
                    const isTitle = typeof documentData[key] === 'object' && documentData[key] !== null;
                    const canUpdatePrimary = applicationData ? !isEqual(documentData[key], applicationData[key]) : false;
                    const canUpdatedSecondary = secondaryApplicationData ? !isEqual(documentData[key], secondaryApplicationData[key]) : false;
                    const currentPath = [...path, key];
                    const pathString = `${fileIndex}.${currentPath.join('.')}`;
                    // Which columns this row has been written into. One button
                    // used to write both, which put one person's employer and
                    // one person's business income on the other borrower's 1003
                    // as well.
                    const updatedColumns = updatedKeys[pathString] || {}
                    const hasUpdatedPrimary = updatedColumns === true || !!updatedColumns.primary
                    const hasUpdatedSecondary = updatedColumns === true || !!updatedColumns.secondary
                    const markColumn = (column, on) => setUpdatedKeys(prev => {
                        const before = prev[pathString] === true
                            ? { primary: true, secondary: true }
                            : (prev[pathString] || {})
                        const after = { ...before, [column]: on }
                        return { ...prev, [pathString]: (after.primary || after.secondary) ? after : false }
                    })
                    const handleMouseEnter = (column) => () => setHoveredKey({ path: pathString, column });
                    const handleMouseLeave = () => setHoveredKey(null);
    
                    const handleUpdateClick = (column) => () => {
                        setHoveredKey(null);
                        markColumn(column, true)
                        const setter = column === 'primary' ? setCurrentData : setCurrentData2
                        setter(prev => {
                            const updated = cloneDeep(prev);
                            setNestedValue(updated[fileIndex], currentPath, documentData[key]);
                            return updated;
                        })
                    };
    
                    const handleUndoClick = (column) => () => {
                        markColumn(column, false)
                        const setter = column === 'primary' ? setCurrentData : setCurrentData2
                        const original = column === 'primary' ? initialData : initialData2
                        setter(prev => {
                            const updated = cloneDeep(prev)
                            setNestedValue(updated[fileIndex], currentPath, getNestedValue(original[fileIndex], currentPath))
                            return updated
                        })
                    }
    
                    const previewing = (column) => hoveredKey && hoveredKey.path === pathString && hoveredKey.column === column
                    const displayValuePrimary = applicationData 
                    ? (previewing('primary') ? documentData[key] : applicationData[key])
                        : null
                    const displayValueSecondary = secondaryApplicationData
                        ? (previewing('secondary') ? documentData[key] : secondaryApplicationData[key])
                        : null
    
                    const displayStylePrimary = applicationData ? (previewing('primary') && applicationData[key] !== documentData[key])
                        ? { fontStyle: 'italic', color: '#325CEB' }
                        : { fontStyle: 'italic' } : {}
    
                    const displayStyleSecondary = secondaryApplicationData ? (previewing('secondary') && secondaryApplicationData[key] !== documentData[key])
                        ? { fontStyle: 'italic', color: '#325CEB' }
                        : { fontStyle: 'italic' } : {}
    
                    
                    return (
                        <div key={key}>
                            <div 
                                className={`field-row ${isTitle ? 'title-row' : ''} 
                                ${(canUpdatePrimary || canUpdatedSecondary) && !isTitle ? 'update-row' : ''}`}
                                style={ updatedKeys[pathString] ? { alignItems: 'flex-start' } : {} }
                            >
                                <div className="field-key" style={{ textIndent: `${level * 38}px` }}>
                                    {key}
                                </div>
    
                                {!isTitle && (
                                    <>
                                        <div className="field-value">{forDisplay(documentData[key])}</div>
    
                                        <div className="field-value" style={applicationData && secondaryApplicationData ? { display: 'flex', flexDirection: 'column', flexGrow: 2 } : {display: 'flex', flexDirection: 'column', flexGrow: 1}}>
                                            <div style={{display: 'flex'}}>
                                                {
                                                    applicationData && (
                                                        <div className='application-row'>
                                                            <div style={displayStylePrimary}>{forDisplay(displayValuePrimary)}</div>
                                                            {hasUpdatedPrimary ? (
                                                                <div className="undo">
                                                                    Updated w/ doc data
                                                                    <span onClick={handleUndoClick('primary')}>Undo</span>
                                                                </div>
                                                            ) : canUpdatePrimary && (
                                                                <div
                                                                    onMouseEnter={handleMouseEnter('primary')}
                                                                    onMouseLeave={handleMouseLeave}
                                                                    onClick={handleUpdateClick('primary')}
                                                                    className='column-update-btn'
                                                                >
                                                                    Update
                                                                </div>
                                                            )}
                                                        </div>
                                                    )
                                                }
                                                {secondaryApplicationData && (
                                                    <div className='application-row' style={{textIndent: 24}}>
                                                        <div style={displayStyleSecondary}>{forDisplay(displayValueSecondary)}</div>
                                                        {hasUpdatedSecondary ? (
                                                            <div className="undo">
                                                                Updated w/ doc data
                                                                <span onClick={handleUndoClick('secondary')}>Undo</span>
                                                            </div>
                                                        ) : canUpdatedSecondary && (
                                                            <div
                                                                onMouseEnter={handleMouseEnter('secondary')}
                                                                onMouseLeave={handleMouseLeave}
                                                                onClick={handleUpdateClick('secondary')}
                                                                className='column-update-btn'
                                                            >
                                                                Update
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className='field-action'></div>
                                    </>
                                )}
                            </div>
                            {isTitle && (
                                <RecursiveTable
                                    documentData={documentData[key]}
                                    applicationData={applicationData ? applicationData[key] : null}
                                    secondaryApplicationData={secondaryApplicationData ? secondaryApplicationData[key] : null}
                                    level={level + 1}
                                    path={currentPath}
                                    hoveredKey={hoveredKey}
                                    setHoveredKey={setHoveredKey}
                                    fileName={fileName}
                                    fileIndex={fileIndex}
                                />
                            )}
                        </div>
                    );
                })}
            </div>
        );
    };
    function getFileExtension(filename) {
        return filename.slice((filename.lastIndexOf(".") - 1 >>> 0) + 2)
    }
    const removeFileExtension = (fileName) => {
        return fileName.replace(/\.[^/.]+$/, "")
    }
    const footer = [
        <Button className="verify-cancel-btn" onClick={verifyCancel}>Back</Button>,
        mode === 'smart' ? (
            countDiscrepancies(data1, currentData, currentData2) < countDiscrepancies(data1, initialData, initialData2) ? <Button className="verify-complete-btn" type="primary" onClick={handleVerify}>Complete verification</Button> : <Button className="verify-skip-btn" type="link" onClick={handleVerify}>Dismiss suggestions and complete verification</Button>
        ) : (
            <div style={{display: 'flex', alignItems: 'center'}}>{changeSaved ? <div className='change-saved'>Changes saved to 1003<img src='/images/document/change-saved.svg' /></div> : <Button style={{marginRight: 30}} className="verify-skip-btn" type="link" onClick={saveProgress}>Save progress</Button>}<Button className="verify-complete-btn" type="primary" onClick={manualComplete}>Complete verification</Button></div>
        )
    ]
    const getName = (type) => {
        const first = type === 'coborrower' ? smartRightName : smartLeftName
        if (first) return `${first}’s 1003 Application`
        return '1003 Application'
    }
    const renderFileData = (file, index) => {
        return (
            <div key={file.name}>
                <div className='update-table-header'>
                    <div className='header-col'><div className='file-name'><img src={ getFileExtension(file.name) === "pdf" ? '/images/pdf-icon.svg' : '/images/img-icon.svg'}/><div>{removeFileExtension(file.name)}</div></div></div>
                    <div className='header-col doc'>Document data</div>
                    <div className='header-col application-col' style={currentData.length === 0 || currentData2.length === 0 ? {flexGrow: 1} : {flexGrow: 2}}>
                        {currentData.length > 0 && <div className='header-col application'>{getName('borrower')}</div>}
                        {currentData2.length > 0 && <div style={{textIndent: 24}} className='header-col application'>{getName('coborrower')}</div>}
                    </div>
                    <div style={{ width: 95 }}></div>
                </div>
                <div className='update-table'>
                {/* Without this the file's name heads an empty stretch of
                    screen and the reviewer is left guessing. */}
                {Object.keys(data1[index] || {}).length === 0 &&
                    <div className='no-mapped-fields'>No 1003 fields to compare for this document.</div>}
                <RecursiveTable
                    documentData={data1[index]}
                    applicationData={currentData.length > 0 ? currentData[index] : null}
                    secondaryApplicationData={currentData2.length > 0 ? currentData2[index] : null}
                    hoveredKey={hoveredKey}
                    setHoveredKey={setHoveredKey}
                    fileName={file.name}
                    fileIndex={index}
                />
                </div>
            </div>
        );
    }
    const handleChangeBorrower = (value) => {
        setViewType(value)
    }
    
    const verifyConfirmCancel = () => {
        setVerifyConfirmStatus(false)
    }
    const verifyCoborrower = () => {
        const nextPerson = borrowerOptions.find((item) => item.value !== viewType)
        setVerifyConfirmStatus(false)
        setViewType(nextPerson?.value || viewType)
    }
    const handleMouseEnter = () => {
        setPreviewBarVisible(true)
        if (hideTimeout) {
            clearTimeout(hideTimeout)
            setHideTimeout(null)
        }
    }

    const handleMouseLeave = () => {
        const timeout = setTimeout(() => {
            setPreviewBarVisible(false)
        }, 3000)
        setHideTimeout(timeout)
    }
    return (
        <>
            <Modal
                className='document-verify-modal'
                styles={{ mask: { backgroundColor: 'rgba(0, 0, 0, 0.85)' } }}
                destroyOnClose
                maskClosable={true}
                width='90%'
                open={open}
                title=""
                onCancel={verifyCancel}
                footer={footer}
            >
                <div className='verify-modal-top'><div>Document verification | {data?.taskName}</div>{mode === 'manual' && <Button className="verify-skip-btn" type="link" onClick={() => handleDoc({key: 'resubmission'})}>Request document resubmission</Button>}</div>
                {
                    mode === 'smart' ? (
                        <div className='verify-modal-content'>
                            <div className='verify-title'>Our AI checked for discrepancies between the document data and the 1003 application form.</div>
                            <div style={countDiscrepancies(data1, currentData, currentData2) === 0 ? {backgroundColor: '#E1F2E2'} : {}} className='update-action-bar'>
                                <div className='action-bar-l'>
                                    <img src={`/images/document/verify-${countDiscrepancies(data1, currentData, currentData2) === 0 ? 'passed' : 'difference'}.svg`} />
                                    {countDiscrepancies(data1, currentData, currentData2) === 0 ? <div style={{color: '#2E605A'}}>All information is correct</div> : <div>{countDiscrepancies(data1, currentData, currentData2)} discrepancies were detected. Update the 1003 application form’s data?</div>}
                                </div>
                                {
                                    countDiscrepancies(data1, currentData, currentData2) === 0 ? (
                                        isUpdateAll ? <div className='undo-all'><span>All updates applied</span><div className='undo' onClick={undoAll}>Undo</div></div> : null 
                                    ) : (
                                        <div className='update-all' onClick={updateAll}>Update all</div>
                                    )
                                }
                                
                            </div>
                            <div className='verify-table'>
                                {files && files.length > 0 && (
                                    files.map((file, index) => renderFileData(file, index))
                                )}
                            </div>
                        </div>
                    ) : (
                        <div className='manual-modal-content'>
                            <Row>
                                <Col style={{position: 'relative'}} span={12}>
                                    <div className='document-preview-content' ref={containerRef} onScroll={handleScroll}>
                                        <div style={{ width: pageWidth * scale }} className='preview-box'>
                                            {
                                                data?.MimeType === "application/pdf" ? (
                                                    <Document error={<Skeleton active />} loading={<Skeleton active />} file={file} onLoadSuccess={onDocumentLoadSuccess}>
                                                        {Array.from(new Array(numPages), (_, index) => (
                                                            <div
                                                                id={`pdfVerifyPage-${index + 1}`}
                                                                key={`page_${index + 1}`}
                                                                data-page={index + 1}
                                                                ref={(ref) => (pageRefs.current[index] = ref)}
                                                                style={{ width: pageWidth * scale }}
                                                                className="pdf-verify-anchor"
                                                            >
                                                                {visiblePages.includes(index + 1) ? (
                                                                    <Page
                                                                        loading={<Skeleton active />}
                                                                        renderAnnotationLayer={false}
                                                                        pageNumber={index + 1}
                                                                        width={pageWidth * scale}
                                                                    />
                                                                ) : (
                                                                    <Skeleton active />
                                                                )}
                                                            </div>
                                                        ))}
                                                    </Document>
                                                ) : (
                                                    <Image
                                                        preview={false}
                                                        width={pageWidth * scale}
                                                        src={createImageURLFromBase64(file, data?.MimeType )}
                                                    />
                                                )

                                            }
                                        </div>
                                    </div>
                                    <div 
                                        className='document-preview-top-bar'
                                        onMouseEnter={handleMouseEnter}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <div className={`change-file ${previewBarVisible ? 'visible' : ''}`}>
                                            <img className={`prev-file ${data?.num === 1 && 'arrow-disabled'}`} src={`/images/document-arrow-left-disabled.svg`} onClick={() => changeFile('prev')}/>
                                            <div className='flie-total'>File <span>{data?.num} / {data?.total}</span></div>
                                            <div className='separate'></div>
                                            <div className='file-name'><img src={ data?.MimeType === "application/pdf" ? '/images/pdf-icon.svg' : '/images/img-icon.svg'}/><div>{data?.FileName.replace(/\.[^/.]+$/, "")}</div></div>
                                            <img className={`next-file ${data?.num === data?.total && 'arrow-disabled'}`} src={`/images/document-arrow-right-disabled.svg`} onClick={() => changeFile('next')}/>
                                        </div>
                                    </div>
                                    <div className='document-preview-bottom-bar'>
                                        <div className="document-preview-pagination">
                                            <Pagination size='small' simple current={data?.MimeType === "application/pdf" ? currentPage : 1} pageSize={1} total={data?.MimeType === "application/pdf" ? numPages : 1} onChange={onChangePage} />
                                        </div>
                                        <div className="document-preview-scale">
                                            <div className='zoom-min'><MinusOutlined style={{ fontSize: 16 }} onClick={() => changeZoom('min')} /></div>
                                            <div className='zoom-value'>{Math.round(scale * 100)}%</div>
                                            <div className='zoom-add'><PlusOutlined style={{ fontSize: 16 }} onClick={() => changeZoom('add')} /></div>
                                        </div>
                                    </div>
                                </Col>
                                <Col span={12} className="form-1003-col">
                                    <div className='form-1003-title'>
                                        <div>1003 Application Form</div>
                                        { borrowerOptions.length > 1 &&
                                            <Select
                                                style={{height: 36}}
                                                value={viewType}
                                                onChange={handleChangeBorrower}
                                                options={borrowerOptions}
                                            />
                                        }
                                    </div>
                                    <div className="form-1003-body">
                                        <Interview1003ViewV2
                                            loanId={loanid}
                                            partyId={borrowerOptions.find((item) => item.value === viewType)?.partyId || ""}
                                            partyName={borrowerOptions.find((item) => item.value === viewType)?.label || ""}
                                            onSwitchToPrimaryParty={(primaryPartyId) => {
                                                const primary = borrowerOptions.find((item) => item.partyId && item.partyId === primaryPartyId)
                                                    || borrowerOptions[0]
                                                if (primary) setViewType(primary.value)
                                            }}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    )
                }
            </Modal>
            <Modal
                className='verify-confirm-modal'
                centered 
                width={500}
                open={verifyConfirmStatus}
                onCancel={verifyConfirmCancel}
                footer={null}
            >   
                <div className='verify-confirm-title'>Confirm Verification Completion</div>
                <div className='verify-confirm-text'>It seems you have completed verifying {borrowerOptions.find(item => item.value === viewType)?.label}’s 1003 Application Form. Would you like to verify {borrowerOptions.find(item => item.value !== viewType)?.label}'s 1003 Application Form as well?</div>
                <div className='verify-confirm-action'>
                    <div className='confirm-btn theme-btn' onClick={verifyCoborrower}>View {borrowerOptions.find(item => item.value !== viewType)?.label}’s 1003 Application Form</div>
                    <div className='confirm-btn default-btn' onClick={completeVerify}>Complete Verification Anyway</div>
                </div>
            </Modal>
        </>
    )
}
VerifyModal = connect(mapStateToProps, mapDispatchToProps)(VerifyModal)